import React from 'react'

import Storeprofile from './storeProfile'

export default function StoreCommission() {
  return <Storeprofile showStoreCommission />
}
